import { render, staticRenderFns } from "./RelatedArticleModal.vue?vue&type=template&id=1c7e6b14&lang=pug&"
import script from "./RelatedArticleModal.vue?vue&type=script&lang=js&"
export * from "./RelatedArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports